"use strict";

// Top Swiper
const topSwiper = new Swiper(".mainView-swiper", {
    loop: true,
    speed: 1000,
    slidesPerView: 1,

    autoplay: {
        delay: 2500,
        disableOnInteraction: false,
    },

    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },

    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});

// Third Section Swipers
const thirdSectionSwiperTop = new Swiper(".thirdSectionTop-swiper", {
    loop: true,
    speed: 1000,
    slidesPerView: 5,

    autoplay: {
        delay: 2500,
        disableOnInteraction: false,
    },

    breakpoints: {
        768: {
            slidesPerView: 3,
        },
        1024: {
            slidesPerView: 4,
        },
        425: {
            slidesPerView: 1,
        },
        0: {
            slidesPerView: 1,
        },
    },

    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },

    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});

const thirdSectionSwiperCenter = new Swiper(".thirdSectionCenter-swiper", {
    loop: true,
    speed: 1000,
    slidesPerView: 5,

    autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        reverseDirection: true,
    },

    breakpoints: {
        768: {
            slidesPerView: 3,
        },
        1024: {
            slidesPerView: 4,
        },
        425: {
            slidesPerView: 1,
        },
        0: {
            slidesPerView: 1,
        },
    },

    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },

    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});

const thirdSectionSwiperBottom = new Swiper(".thirdSectionBottom-swiper", {
    loop: true,
    speed: 1000,
    slidesPerView: 5,

    autoplay: {
        delay: 2000,
        disableOnInteraction: false,
    },

    breakpoints: {
        768: {
            slidesPerView: 3,
        },
        1024: {
            slidesPerView: 4,
        },
        425: {
            slidesPerView: 1,
        },
        0: {
            slidesPerView: 1,
        },
    },

    pagination: {
        el: ".swiper-pagination",
        clickable: true,
    },

    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
});



// What's New Paragraph
function updateTextLength() {
    let maxLength;
    const width = window.innerWidth;

    if (width <= 428) {
        maxLength = 60;
    } else if (width <= 834) {
        maxLength = 450;
    } else if (width <= 1200) {
        maxLength = 550;
    } else {
        maxLength = 100;
    }

    const paragraphs = document.querySelectorAll(".paragraph");

    paragraphs.forEach((paragraph) => {
        let originalText =
            paragraph.getAttribute("data-original-text") || paragraph.innerText;
        paragraph.setAttribute("data-original-text", originalText);

        let text = originalText;

        if (text.length > maxLength) {
            text = text.substring(0, maxLength) + "...";
        }
        paragraph.innerText = text;
    });
}

window.addEventListener("resize", updateTextLength);
window.addEventListener("DOMContentLoaded", updateTextLength);
